module.exports = __webpack_public_path__ + "img/Group_325@2x.3c44d958.png";